'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'cup-straw';
var width = 384;
var height = 512;
var aliases = [129380];
var unicode = 'e363';
var svgPathData = ['M48.1 112l287.9 0-28.4 354.6c-1.3 16.6-15.2 29.4-31.9 29.4l-167.4 0c-16.7 0-30.6-12.8-31.9-29.4L48.1 112z', 'M232.6-16c-18.1 0-34 12.2-38.6 29.7L172 96 8 96c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 28.5 355.8c2 24.9 22.8 44.2 47.8 44.2l167.4 0c25 0 45.9-19.2 47.8-44.2L352 112 376 112c4.4 0 8-3.6 8-8s-3.6-8-8-8l-187.5 0 20.8-78.2C212.2 7.3 221.7 0 232.6 0L280 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-47.4 0zM48.1 112l287.9 0-28.4 354.6c-1.3 16.6-15.2 29.4-31.9 29.4l-167.4 0c-16.7 0-30.6-12.8-31.9-29.4L48.1 112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCupStraw = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;